(function (app) {

    app.provider("transactionGroupApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function (transactionGroupId) {
                        return complianceHubApiGateway.get("/TransactionGroups/" + transactionGroupId);
                    };

                    service.getTransactionGroupUsers = function(transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/Users");
                    };

                    service.getTransactionGroupAgents = function (transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/Agents");
                    };                   

                    service.getTransactionGroupPossibleDelegates = function (transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/Delegates");
                    };

                    service.getTransactionGroupArcBusinessAgents = function(transactionGroupId, businessId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/Businesses/" + businessId + "/Agents/Arc");
                    };

                    service.getTransactionGroups = function () {
                        return complianceHubApiGateway.getArray("/TransactionGroups");
                    };

                    service.getTransactionGroup = function (transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId);
                    };

                    service.getLogo = function (transactionGroupId) {
                        return complianceHubApiGateway.getFile("/TransactionGroups/" + transactionGroupId + "/Logo", { headers: { "Accept": "image/*" } });
                    };

                    service.getQueueWorkflow = function (queueWorkflowId) {
                        return complianceHubApiGateway.get("/QueueWorkflow/" + queueWorkflowId);
                    };

                    service.getTransactionGroupIdsForQueueWorkflow = function(queueWorkflowId) {
                        return complianceHubApiGateway.getArray("/QueueWorkflow/" + queueWorkflowId + "/TransactionGroups");
                    }

                    service.getDisclosures = function (transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/Disclosures");
                    };

                    service.getPublishedTransactionGroup = function(transactionGroupId) {
                        return complianceHubApiGateway.get("/TransactionGroups/" + transactionGroupId + "/Published");
                    }

                    service.getTransactionGroupBds = function() {
                        return complianceHubApiGateway.getArray("/TransactionGroups/BdGroups");
                    }

                    //PUTs
                    service.update = function (transactionGroupId, transactionGroup) {
                        return complianceHubApiGateway.put("/TransactionGroups/" + transactionGroupId, transactionGroup);
                    };

                    service.updateQueueWorkflow = function (workflow) {
                        return complianceHubApiGateway.put("/QueueWorkflow/" + workflow.QueueWorkflowId + "/queues",
                            workflow);
                    };

                    service.updatePaperAppEmails = function(transactionGroup) {
                        return complianceHubApiGateway.put("/TransactionGroups/" + transactionGroup.Id + "/PaperAppEmails",
                            transactionGroup.SubmittedPaperApplicationEmails);
                    };

                    service.updateDisclosures = function(transactionGroup, disclosures) {
                        return complianceHubApiGateway.put("/TransactionGroups/" + transactionGroup.Id + "/Disclosures",
                            disclosures);
                    };

                    service.updateFinancialInstitution = function(transactionGroup, fiId) {
                        return complianceHubApiGateway.put("/TransactionGroups/" + transactionGroup.Id + "/FinancialInstitution/" + fiId);
                    };

                    service.publish = function(transactionGroupId) {
                        return complianceHubApiGateway.put("/TransactionGroups/" + transactionGroupId + "/Publish");
                    };

                    //POSTs
                    service.updateLogo = function (transactionGroupId, logo) {
                        return complianceHubApiGateway.postFile("/TransactionGroups/" + transactionGroupId + "/Logo", logo);
                    };

                    service.createNewTransactionGroup = function (group) {
                        return complianceHubApiGateway.post("/TransactionGroups", group);
                    };

                    // DELETEs
                    service.removeLogo = function(transactionGroupId) {
                        return complianceHubApiGateway.delete("/TransactionGroups/" + transactionGroupId + "/Logo");
                    };

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line